import WidgetService from '../../../services/WidgetService';

export default {
    namespaced: true,
    state: () => ({
        widgets: null,
        autoSelects: {},
    }),
    getters: {
        getWidgets: (state) => state.widgets,
        getWidgetsList: (state) => {
            if (!state.widgets) return [];

            let widgetsList = [];
            state.widgets.forEach((widget, key) => {
                widgetsList.push({
                    'id': key,
                    'name': widget.name,
                    'widget': widget.sysname,
                    'fields': widget.fields.map(fields => {
                        return fields = Object.assign(fields, fields.name === 'icon' ? {value: 'mdi-'} : {value: ''})
                    }),
                    'elements': []
                })
            })
            return widgetsList
        },
    },
    mutations: {
        setWidgets: (state, widgets) => state.widgets = widgets,
        setAutoSelects: (state, data) => {
            state.autoSelects = data
        }
    },
    actions: {
        addWidget: ({dispatch}, widgetData) => {
            return new Promise((resolve, reject) => {
                WidgetService.addWidget(widgetData).then(res => {
                    console.log(res);
                    dispatch('getWidgets');
                    resolve(res)
                }).catch((err) => {
                    reject(err);
                })
            })
        },
        getWidgets: ({commit}) => {
            return new Promise((resolve, reject) => {
                WidgetService.widgets().then(res => {
                    commit('setWidgets', res.data);
                    resolve(res);
                }).catch((err) => {
                    reject(err);
                })
            })
        },
        getAutoSelects: ({commit,state}, data) => {
            return new Promise((resolve) => {
                let autoSelects = state.autoSelects
                if (autoSelects.length > 0) {
                    autoSelects = {...data, ...autoSelects}
                } else {
                    autoSelects = {...data}
                }
                commit('setAutoSelects', autoSelects);
                resolve(autoSelects);
            })
        }
    }
}